<!-- Show navigation only when user is authenticated and not on login page -->
<app-navigation *ngIf="shouldShowNavigation">
  <router-outlet></router-outlet>
</app-navigation>

<!-- Show content directly when not authenticated (login page) -->
<router-outlet *ngIf="!shouldShowNavigation"></router-outlet>
